import { Button } from "devextreme-react"
import { Form, GroupItem, SimpleItem } from "devextreme-react/form"
import notify from "devextreme/ui/notify"
import { useCallback, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { getApiParams } from "../../redux/auth"
import { BodyType, createRequest } from "../../redux/base/request"
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga"
import { getLocalized } from "../../redux/localization"
import { adminSystemPriceUrl } from "../../services/urls"
import { SystemPackagePrice } from "./type"

const SystemPackagePricePage = () => {

    const { token, lang } = useSelector(getApiParams);
    const systemPrice = useRef<SystemPackagePrice>({
        LocationPrice: 0,
        Products10: 0,
        Products20: 0,
        Products30: 0,
        Products40: 0,
        Products50: 0
    })
    const [newPrice, setNewPrice] = useState<SystemPackagePrice>()
    const getSystemPrice = useCallback(async () => {
        const response: ApiResponse<SystemPackagePrice> = await createRequest({
            method: "GET",
            url: adminSystemPriceUrl,
            bodyType: BodyType.formdata,
            body: {},
            token,
            lang,
        });
        if (verfiyResponse(response)) {
            systemPrice.current.LocationPrice = response.Result.LocationPrice
            systemPrice.current.Products10 = response.Result.Products10
            systemPrice.current.Products20 = response.Result.Products20
            systemPrice.current.Products30 = response.Result.Products30
            systemPrice.current.Products40 = response.Result.Products40
            systemPrice.current.Products50 = response.Result.Products50
            setNewPrice(response.Result)
        }
    }, [lang, token])

    useEffect(() => {
        getSystemPrice()
    }, [getSystemPrice])



    const ref = useRef<any>();

    const localize = useSelector(getLocalized);

    return <div
        style={{
            display: "flex",
            flexDirection: "column"
        }}
    >

        <p 
            style={{
                fontSize : "24px",
                fontWeight : "600",
                padding : "15px"
            }}
        >Sistem Fiyatları</p>

        <Form
            formData={newPrice}
            ref={ref}
        >
            <GroupItem colCount={4}>
                <GroupItem colCount={1}>
                    <SimpleItem
                        dataField={"LocationPrice"}
                        editorType="dxNumberBox"
                        label={{
                            text: localize.getString("locationPrice")
                        }}
                    >

                    </SimpleItem>
                    <SimpleItem
                        dataField={"Products10"}
                        editorType="dxNumberBox"
                        label={{
                            text: localize.getString("product10")
                        }}
                    >

                    </SimpleItem>
                    <SimpleItem
                        dataField={"Products20"}
                        editorType="dxNumberBox"
                        label={{
                            text: localize.getString("product20")
                        }}
                    >

                    </SimpleItem>
                    <SimpleItem
                        dataField={"Products30"}
                        editorType="dxNumberBox"
                        label={{
                            text: localize.getString("product30")
                        }}
                    >

                    </SimpleItem>
                    <SimpleItem
                        dataField={"Products40"}
                        editorType="dxNumberBox"
                        label={{
                            text: localize.getString("product40")
                        }}
                    >

                    </SimpleItem>
                    <SimpleItem
                        dataField={"Products50"}
                        editorType="dxNumberBox"
                        label={{
                            text: localize.getString("product40")
                        }}
                    >

                    </SimpleItem>
                </GroupItem>
            </GroupItem>
        </Form>

        <Button
            type="success"
            text="Kaydet"
            width={200}
            style={{
                marginTop : "25px",
                display : "flex",
                justifyContent : "center",
                
            }}
            onClick={async () => {
                const response: ApiResponse<SystemPackagePrice> = await createRequest({
                    method: "POST",
                    url: adminSystemPriceUrl,
                    bodyType: BodyType.raw,
                    body: newPrice,
                    token,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")

                } else notify(response.Message, "error");
            }}
        >

        </Button>

    </div>


}

export default SystemPackagePricePage